<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">热风</div>
          <div class="contentBottom">
            <div>新零售门店的阶段性升级</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:118px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <img :src="productLeft1">
      </div>
      <div class="productRight">
        <div class="productRightText">
          热风是时下广受年轻人欢迎的时尚零售连锁品牌，品牌也从一代店不停迭代，至今已升级六代店。随着新零售的发展，热风致力于进行门店逐步升级，以求达到智能化、交互性的消费体验。需求如下：
          <br>a.一个能管理全国所有门店屏幕的平台
          <br>b.屏幕不止是展示商品海报，还能具备营销作用，为门店引流
          <br>c.平台稳定，可支持终端硬件随时扩容
          <br>d.提供互动型营销方案，提升用户体验感
          <br>e.可通过大屏互动为线上导流，实现线上线下营销一体化
        </div>
      </div>
    </div>
    <!-- end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">方案策略</div>
      <div class="lineCss"></div>
    </div>
    <div class="grayBox">
      <div
        class="grayBoxText"
      >用数拓智屏OS平台，对热风全国门店屏幕进行统一管理。同时，针对热风入口区的引流需求，定制主题化的互动游戏，在引流的同时，实现线上线下导流。提升门店活力和趣味性的同时，为品牌带来用户偏好数据。</div>
      <!-- detailList start -->
      <div class="detailList">
        <div class="detailBox">
          <img :src="detailListIcon1" alt>
          <div class="detailBoxTitle">定制交互游戏</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon2" alt>
          <div class="detailBoxTitle">进准广告投放</div>
        </div>
        
      </div>
      <!-- detailList end -->
    </div>
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:152px">场景功能</div>
      <div class="lineCss"></div>
    </div>
    <div class="leftYellowParent">
      <!-- <div class="leftYellow"></div> -->
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">互动营销，入口引流</div>
        <div class="bottomRightText bottomRightTextTwo">通过智能时段定时播放策略，让海报展示和互动游戏按照时段智能切换。游戏过程中，为品牌公众号加粉，带去线上流量。同时，实时统计交互数据及转化数据，为此次营销策略提供数据基础。</div>
      </div>

      <div class="bottomRight" style="width:50%;">
        <img :src="wanDaContent2" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft" style="width:50%;padding:0;">
        <img :src="wanDaContent3" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle">主题游戏定制</div>
        <div
          class="bottomRightText"
        >根据营销活动的节奏，配合热风品牌要传递的概念，定制多款游戏，如情人节的‘求爱上上签’等，提升顾客与品牌的粘性。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">精准广告投放</div>
        <div class="bottomRightText bottomRightTextTwo">针对热风六代店的升级需求，结合门店不同区域的陈列特点，及装修风格，配置不同的智能屏幕，根据商品上新、下架、爆款推荐、特价活动等营销节奏，进行精准化内容投放，提升销量转化。</div>
      </div>

      <div class="bottomRight" style="width:50%;">
        <img :src="wanDaContent4" alt>
      </div>
    </div>

    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/hotwindTop.png";
import productLeft1 from "@/assets/images/hotwind1.png";

import wanDaContent2 from "@/assets/images/hotwindImg2.png";
import wanDaContent3 from "@/assets/images/hotwindImg3.png";
import wanDaContent4 from "@/assets/images/hotwindImg4.png";
import detailListIcon1 from "@/assets/images/hotwindIcon1.png";
import detailListIcon2 from "@/assets/images/hotwindIcon2.png";
import detailListIcon3 from "@/assets/images/wanDaAnLiIcon3.png";
import detailListIcon4 from "@/assets/images/wanDaAnLiIcon4.png";

import Bread from "@/components/bread.vue";

export default {
  name: "CaseDetailWanDa",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["案例", "万达影城"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 180px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 77px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  max-width: 1200px;
  margin: auto;
}

.productLeft {
  width: 51%;
  float: left;
}

.productLeft img {
  width: 98%;
  /* max-width: 542px; */
}

.productRight {
  width: 46%;
  padding-left: 2%;
  float: left;
}

.productRightTitle {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.marginTop109 {
  margin-top: 59px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 58px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 54px;
  padding-bottom: 64px;
  padding-top: 94px;
}

.detailList {
  display: flex;
  width: 70%;
  margin: auto;
}

.detailBox {
  width: 50%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.productParent {
  margin-top: 50px;
}
.bottomParent {
  width: 70%;
  max-width: 1200px;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 40%;
  float: left;
  padding-left: 10%;
  margin-top: 84px;
}
.bottomLeft img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 100%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 40%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
}
.bottomRightText {
  width: 90%;
  margin-top: 10%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 80%;
  margin-top: 6%;
}
/* 左边 left  start */
.leftYellowParent {
  position: relative;
}
.leftYellow {
  position: absolute;
  left: 0;
  top: 160px;
  width: 12.5%;
  height: 80px;
  background: rgba(252, 200, 0, 1);
}
/* 左边 left  end */
@media screen and (max-width: 1200px) {
  .productRightText {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/CaseHotwind.vue